import React from "react";
import classNames from "classnames";
import styles from "./ensayo-adjunto-card.module.scss";
import { Image, TemplateText } from "../../atoms";

export const EnsayoAdjuntoCard = (props: any) => {
  const { imagen, descripcion, card = false } = props;
  return (
    <div className={classNames(styles.root, { [styles.card]: card })}>
      <div className={styles.imageWrapper}>
        <Image
          className={classNames(styles.imagen)}
          src={imagen}
          alt={"manvert" + descripcion}
        />
      </div>
      <TemplateText template="small">{descripcion}</TemplateText>
    </div>
  );
};
